<!-- 选择学员在班情况 -->
<template>
  <el-form-item :label="label">
      <el-select v-model="studentIn" ref="selectJS"  fit-input-width  placeholder="请选择" :clearable="true" @focus="auditionAdd"
            filterable  remote>
            <el-option v-for="item in studentList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-学员介绍人选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => (''),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '介绍人：',
    },
  },
  setup(props) {
    const popup = inject('popup');
    const useQuery = inject('useQuery');
    const studentList = ref([]);
    function reset() {
      // eslint-disable-next-line no-use-before-define
      studentIn.value = props.value;
      studentList.value = [];
    }
    const studentIn = useQuery('studentIn', props.value, reset);
    const selectJS = ref(null);
    //
    async function auditionAdd() {
      selectJS.value.blur();
      await popup('base-student-chooser', {
        title: '选择介绍人',
        isShowTips: false,
        tipsStr: '',
        queryParams: {
          campusIds: [],
          displayHistory: false,
          intentionStatus: '',
          scene: 0,
        },
        lists: studentList.value,
        multiple: false,
        beforeConfirmFun: async (sts) => {
          if (sts.length) {
            studentList.value = sts;
            studentIn.value = studentList.value[0].id;
          } else {
            studentList.value = [];
            studentIn.value = '';
          }
        },
      });
    }

    return {
      studentIn,
      studentList,
      selectJS,
      auditionAdd,
    };
  },
};
</script>
